export const IMG_URl = "https://kriechapi.krieshrestaurant.com/storage/";
// export const IMG_URl = "http://127.0.0.1:8000/storage/";
// 